import { ControlIcons } from 'owa-control-icons';
import { isFeatureEnabled } from 'owa-feature-flags';
import { getListViewNotificationDimensions } from 'owa-mail-list-dimensions';
import * as undoActions from 'owa-mail-undo';
import { lazyShowNotification, NotificationBarCallbackReason } from 'owa-notification-bar';
import { format } from 'owa-strings';
import strings from 'owa-strings/owa-mail-strings';
import { getUserConfiguration } from 'owa-session-store';

/**
 * show notification on delete
 * @param numberOfItems acted on for the delete action
 */
export default function showNotificationOnDelete(numberOfItems: number, allowUndo: boolean) {
    if (
        !isFeatureEnabled('tri-notificationBar') ||
        !getUserConfiguration().UserOptions.ShowNotificationBar
    ) {
        return;
    }

    const notificationText =
        numberOfItems === 1
            ? strings.deleteItemSucceededNotification
            : format(strings.deleteItemsSucceededNotification, numberOfItems);
    const notificationDimensions = getListViewNotificationDimensions();

    lazyShowNotification.importAndExecute('deleteNotification', notificationText, {
        icon: ControlIcons.Delete,
        primaryActionText: allowUndo ? strings.undoAction : null,
        // Want 12 px of padding on either side of the notificaiton bar
        minWidth: notificationDimensions.minWidth,
        maxWidth: notificationDimensions.maxWidth,
        notificationCallback: reason => {
            if (reason === NotificationBarCallbackReason.PrimaryActionClicked) {
                undoActions.lazyUndo.importAndExecute('NotificationBar');
            }
        },
    });
}
